import { type ReactElement, useEffect, useState } from 'react';
import { type Scope } from '@sentry/browser';

import { type FragmentProperties } from './Fragment';
import { getFragmentName } from './getFragmentName';
import { createClient } from './sentry';
import { SentryErrorBoundary } from './SentryErrorBoundary';

// eslint-disable-next-line react/function-component-definition
function SentryWrapper<PropertiesType>({
    children,
    sentry,
}: {
    readonly children: ReactElement;
    readonly sentry: FragmentProperties<PropertiesType>['sentry'];
}): JSX.Element {
    const [sentryClient, setSentryClient] = useState<Scope | undefined>(undefined);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.Sentry && sentry?.enabled) {
            const { dsn, environment, release } = sentry;

            setSentryClient(
                createClient({
                    fragmentId: getFragmentName(),
                    dsn,
                    environment,
                    release,
                }),
            );
        }
    }, [sentry]);

    return (
        <SentryErrorBoundary dsn={sentry?.dsn} sentryClient={sentryClient}>
            {children}
        </SentryErrorBoundary>
    );
}

export { SentryWrapper };
